<template>
    <div class="renderPage animate-fade-in reporte-container">
        <!-- Header Section -->
        <v-toolbar color="primary" dark flat class="mb-4 rounded-xl">
            <v-icon class="mr-2" size="24">mdi-monitor-dashboard</v-icon>
            <v-toolbar-title class="text-subtitle-1 text-sm-h5 font-weight-black px-0 text-uppercase">
                Control Ventas
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="white" to="/home" class="glass-btn">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-container fluid class="pa-0">
            <v-row>
                <!-- Filters Area -->
                <v-col cols="12" class="mb-2">
                    <v-card class="glass-card rounded-xl pa-4 elevation-2">
                        <v-form ref="form" v-model="valid">
                            <v-row align="center">
                                <!-- Periodo -->
                                <v-col cols="12" sm="4" md="3" class="py-1">
                                    <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="dates" persistent width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="dates" label="Periodo" prepend-inner-icon="mdi-calendar" readonly required
                                                :rules="dateRules" v-bind="attrs" v-on="on" outlined dense rounded hide-details></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dates" range color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="dateModal = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(dates)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>

                                <!-- Usuarios -->
                                <v-col cols="12" sm="4" md="3" class="py-1">
                                    <v-select label="Usuarios" item-text="nombre" item-value="cedula" v-model="reporte.cedula" :items="usuarios"
                                        :disabled="!validUsuarios" outlined dense rounded hide-details prepend-inner-icon="mdi-account"></v-select>
                                </v-col>

                                <!-- Generar Botón -->
                                <v-col cols="9" sm="3" md="3" class="py-1 d-flex align-center">
                                    <v-btn color="primary" class="rounded-pill font-weight-bold" elevation="2" @click="getReport()" :disabled="!valid" height="40" block>
                                        <v-icon left>mdi-file-document-outline</v-icon>
                                        Generar
                                    </v-btn>
                                </v-col>

                                <!-- Progress Spinner -->
                                <v-col cols="3" sm="1" md="1" class="py-1 d-flex justify-center flex-column align-center">
                                    <v-progress-circular :size="40" :width="4" color="primary" indeterminate v-if="visibleProgress"></v-progress-circular>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card>
                </v-col>

                <!-- Summary Dashboard Cards -->
                <v-col cols="12" v-if="validInfo">
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <v-card class="glass-card rounded-xl pa-4 text-center elevation-2 d-flex flex-column align-center justify-center">
                                <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1">Ventas</span>
                                <span class="text-h6 font-weight-black primary--text">{{ venta.replace('Ventas: ', '') }}</span>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-card class="glass-card rounded-xl pa-4 text-center elevation-2 d-flex flex-column align-center justify-center">
                                <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1">Premios</span>
                                <span class="text-h6 font-weight-black error--text">{{ premios.replace('Premios: ', '') }}</span>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-card class="glass-card rounded-xl pa-4 text-center elevation-2 d-flex flex-column align-center justify-center">
                                <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1">Comisión</span>
                                <span class="text-h6 font-weight-black warning--text">{{ comisionAdmin.replace('Comisión: ', '') }}</span>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-card class="glass-card rounded-xl pa-4 text-center elevation-2 d-flex flex-column align-center justify-center">
                                <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1">Total Admin</span>
                                <span class="text-h6 font-weight-black success--text">{{ totalAdmin.replace('Total Admin: ', '') }}</span>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>

                <!-- Data Table Area -->
                <v-col cols="12" v-if="validInfo">
                    <v-card class="rounded-xl overflow-hidden glass-card elevation-2">
                        <v-data-table 
                            :headers="headers" 
                            :items="items"
                            class="premium-table"
                            mobile-breakpoint="0"
                        >
                            <template v-slot:[`item.venta`]="{ item }">
                                <span class="font-weight-medium">₡{{ item.venta }}</span>
                            </template>
                            <template v-slot:[`item.premios`]="{ item }">
                                <span class="error--text font-weight-bold">₡{{ item.premios }}</span>
                            </template>
                            <template v-slot:[`item.comisionAdmin`]="{ item }">
                                <span class="warning--text font-weight-bold">₡{{ item.comisionAdmin }}</span>
                            </template>
                            <template v-slot:[`item.totalAdmin`]="{ item }">
                                <span class="success--text font-weight-black">₡{{ item.totalAdmin }}</span>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    components: {},
    data() {
        return {
            valid: false,
            validDecargar: false,
            validInfo: false,
            validUsuarios: false,
            dateModal: false,
            visibleProgress: false,
            dates: [],
            items: [],
            usuarios: [],
            venta: 'g',
            premios: 'g',
            comisionAdmin: 'g',
            totalAdmin: 'g',
            dateRules: [
                (v) => v.length == 2 || "Fecha Inicial y Fecha Final Requeridas",
            ],
            headers: [
                {
                    text: "Sorteo",
                    align: "start",
                    value: "sorteo",
                },
                {
                    text: "Fecha",
                    align: "start",
                    value: "fechaSorteo",
                },
                {
                    text: "Venta",
                    align: "start",
                    value: "venta",
                },
                {
                    text: "Premios",
                    align: "start",
                    value: "premios",
                },
                {
                    text: "Comisión",
                    align: "start",
                    value: "comisionAdmin",
                },
                {
                    text: "Total Admin",
                    align: "start",
                    value: "totalAdmin",
                },
            ],
            reporte: {
                cedula: "",
                fechaInicio: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
                fechaFin: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
            },
        };
    },

    computed: {
        ...mapGetters(["user", "strCia"]),
    },

    created() {
        this.reporte.cedula = this.user.cedula;
        this.getUsuariosPorCia();
    },

    methods: {
        getReport() {
            this.visibleProgress = true;
            this.getReporteVentas();
            //this.getRecibidos();
        },

        getReporteVentas() {
            let me = this;
            axios
                .get(
                    "api/Tiempos/GetReporteControlVentas?idUsuario=" +
                    this.reporte.cedula +
                    "&fechaInicio=" +
                    this.dates[0].toString() +
                    "&fechaFin=" +
                    this.dates[1].toString() +
                    "&companyId=" +
                    this.strCia,
                )
                .then(function (response) {
                    me.visibleProgress = false;
                    me.items = response.data;
                    me.venta = "Ventas: " + response.data[0].venta;
                    me.premios = "Premios: " + response.data[0].premios;
                    me.comisionAdmin = "Comisión: " + response.data[0].comisionAdmin;
                    me.totalAdmin = "Total Admin: " + response.data[0].totalAdmin;
                    me.validInfo = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getUsuariosPorCia() {
            let me = this;
            axios
                .get(
                    "api/Usuarios/getUsuariosPorCia?companyId=" +
                    this.strCia,
                )
                .then(function (response) {
                    me.usuarios = response.data;
                    console.log(me.user.cedula);
                    const myUser = me.usuarios.find(user => user.cedula === me.user.cedula);
                    console.log(myUser.tipo);
                    if (myUser.tipo === true) {
                        me.reporte.cedula = "0";
                        me.validUsuarios = true;
                    } else {
                        me.reporte.cedula = myUser.cedula;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        closed() {
            this.customerModal = false;
        },
    },
};
</script>

<style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

/* Table Styling */
.premium-table {
    background: transparent !important;
}

.premium-table >>> th {
    background: rgba(0, 0, 0, 0.03) !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.7rem !important;
}

.theme--dark .premium-table >>> th {
    background: rgba(255, 255, 255, 0.05) !important;
}

.premium-table >>> tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}
</style>